<template>
  <div class="relative z-0">
    <BaseShape
      v-for="shape in shapes"
      :key="shape.shape"
      class="absolute top-0 h-4 w-4 opacity-0"
      :class="[shape.classes, animation]"
      :shape="shape.shape"
      :style="{ 'animation-delay': shape.delay }"
    />
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import BaseShape from '../base/shapes/BaseShape.vue'

  interface Props {
    direction?: 'left' | 'right'
  }

  const { direction = 'right' } = defineProps<Props>()

  const shapes = [
    { shape: 'pill', delay: '0ms', classes: 'text-secondary-container' },
    {
      shape: 'triangle',
      delay: '1000ms',
      classes: 'text-tertiary-container top-1/2 -translate-y-1/2',
    },
    {
      shape: 'puffy diamond',
      delay: '2400ms',
      classes: 'text-primary-container top-1/3 -translate-y-1/2',
    },
    {
      shape: 'burst',
      delay: '3000ms',
      classes: 'text-secondary-container top-full -translate-y-full',
    },
  ] as const

  const animation = computed(() => {
    if (direction == 'left') {
      return 'animate-flow-left'
    }
    return 'animate-flow-right'
  })
</script>
